import TextField from "@mui/material/TextField"
import { DatePicker } from "@mui/x-date-pickers"
import dayjs, { Dayjs } from "dayjs"
import DateRangeIcon from "@mui/icons-material/DateRange"
import { useSelector } from "react-redux/es/hooks/useSelector"
import { RootState } from "../../../../../../app/store"
import { useDispatch } from "react-redux/es/exports"
import { setInterviewDateState } from "../../dialogs/model/Interviews"

import FilesUpload from "./filesUpload/FilesUpload"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"

const PersonalInformationTab = ({
  register,
  watch,
  setValue,
  clearErrors,
  formState,
  setFiles,
  uploading,
  interviewMode,
  interviewRow,
  files,
}: any) => {
  const { errors } = formState

  const interviewDate = useSelector((state: RootState) => state.interviewDate)
  const dispatch = useDispatch()

  console.log(interviewRow.personalInformation.dateOfBirth, "dob")
  console.log(watch("personalInformation.dateOfBirth"), "dob2")

  return (
    <Stack direction={"column"} spacing={"20px"}>
      <Stack direction={"row"} spacing={"40px"}>
        <Stack direction={"column"} spacing={"20px"} sx={{ width: "480px" }}>
          <Stack direction={"column"} spacing={"5px"}>
            <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
              Дата рождения *
            </Typography>
            <DatePicker
              slots={{
                openPickerIcon: DateRangeIcon,
              }}
              sx={{
                ".MuiIconButton-root": { color: "rgba(139, 139, 139, 1)" },
              }}
              value={
                interviewMode.mode === "edit"
                  ? interviewRow.personalInformation.dateOfBirth
                    ? dayjs(watch("personalInformation.dateOfBirth"))
                    : null
                  : interviewDate.dateOfBirth
              }
              localeText={{
                toolbarTitle: "ДД.ММ.ГГГГ",
                fieldDayPlaceholder: () => "ДД",
                fieldMonthPlaceholder: () => "ММ",
                fieldYearPlaceholder: () => "ГГГГ",
              }}
              onChange={(e: Dayjs | null) => {
                dayjs(e).isValid() &&
                  clearErrors("personalInformation.dateOfBirth")
                setValue(
                  "personalInformation.dateOfBirth",
                  dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
                )
                dispatch(
                  setInterviewDateState({
                    ...interviewDate,
                    dateOfBirth: dayjs(e),
                  }),
                )
              }}
              format="DD.MM.YYYY"
              slotProps={{
                textField: {
                  inputProps: register("personalInformation.dateOfBirth", {
                    required: "Это поле обязательно для заполнения",
                  }),

                  size: "small",
                  variant: "outlined",
                  placeholder: "ДД.ММ.ГГГГ",
                  error: errors?.personalInformation?.dateOfBirth?.message,
                  helperText: errors?.personalInformation?.dateOfBirth?.message,
                },
              }}
            />
          </Stack>
          <Stack direction={"column"} spacing={"5px"}>
            <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
              Город *
            </Typography>
            <TextField
              size="small"
              inputProps={register("personalInformation.city", {
                required: "Это поле обязательно для заполнения",
              })}
              fullWidth
              value={watch("personalInformation.city")}
              placeholder="Город"
              error={!!errors.personalInformation?.city}
              helperText={errors.personalInformation?.city?.message || ""}
            />
          </Stack>
          <Stack direction={"column"} spacing={"5px"}>
            <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
              Резюме
            </Typography>
            <TextField
              size="small"
              inputProps={register("personalInformation.resume")}
              fullWidth
              value={watch("personalInformation.resume")}
              placeholder="Ссылка на резюме"
            />
          </Stack>
        </Stack>
        <Stack direction={"column"} spacing={"20px"} sx={{ width: "480px" }}>
          <Stack direction={"column"} spacing={"5px"}>
            <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
              Мобильный телефон *
            </Typography>

            <TextField
              size="small"
              fullWidth
              value={watch("personalInformation.mobilePhone")}
              placeholder="Мобильный телефон"
              error={!!errors.personalInformation?.mobilePhone}
              helperText={
                errors.personalInformation?.mobilePhone?.message || ""
              }
              type="tel"
              InputProps={{
                ...register("personalInformation.mobilePhone", {
                  required: "Это поле обязательно для заполнения",
                  minLength: {
                    value: 10,
                    message: "Минимальная длина 10 цифр",
                  },
                }),
              }}
            />
          </Stack>
          <Stack direction={"column"} spacing={"5px"}>
            <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
              Почта *
            </Typography>
            <TextField
              size="small"
              inputProps={register("personalInformation.email", {
                required: "Это поле обязательно для заполнения",
              })}
              fullWidth
              value={watch("personalInformation.email")}
              placeholder="Почта"
              type="email"
              error={!!errors.personalInformation?.email}
              helperText={errors.personalInformation?.email?.message || ""}
            />
          </Stack>
          <Stack direction={"column"} spacing={"5px"}>
            <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
              Телеграм *
            </Typography>
            <TextField
              inputProps={register("personalInformation.telegram", {
                required: "Это поле обязательно для заполнения",
              })}
              size="small"
              error={!!errors.personalInformation?.telegram}
              helperText={errors.personalInformation?.telegram || ""}
              fullWidth
              value={watch("personalInformation.telegram")}
              placeholder="Телеграм"
            />
          </Stack>
        </Stack>
      </Stack>
      <FilesUpload
        files={files}
        setFiles={setFiles}
        uploading={uploading}
        interviewMode={interviewMode}
        setValue={setValue}
        interviewRow={interviewRow}
      />
    </Stack>
  )
}

export default PersonalInformationTab
